import {NgModule} from '@angular/core';
import {UnsavedChangesNotifierService} from '@application/helper/unsaved-changes-notifier/unsaved-changes-notifier.service';
import {HttpProductionSchedulesService} from '@infrastructure/http/production-schedule/http-production-schedules.service';
import {PRODUCTION_SCHEDULES} from '@infrastructure/http/production-schedule/production-schedules';
import {HttpTuftProductsService} from '@infrastructure/http/tuft-product/http-tuft-products.service';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {SharedModule} from '@shared/shared.module';
import {CanShowErrorForFormControlModule} from '@vdw/angular-component-library';
import {AddTuftProductionOrderPageComponent} from './add/add-tuft-production-order-page.component';
import {SelectTuftProductComponent} from './add/select-tuft-product/select-tuft-product.component';
import {TuftProductionOrderOverviewPageComponent} from './overview/tuft-production-order-overview-page.component';
import {TuftProductionOrderSettingsComponent} from './settings/tuft-production-order-settings.component';
import {tuftProductionOrderRouting} from './tuft-production-order.routing';

@NgModule({
  imports: [tuftProductionOrderRouting, TextileDataSharedModule, CanShowErrorForFormControlModule, SharedModule],
  providers: [HttpTuftProductsService, {provide: PRODUCTION_SCHEDULES, useClass: HttpProductionSchedulesService}, UnsavedChangesNotifierService],
  declarations: [TuftProductionOrderOverviewPageComponent, AddTuftProductionOrderPageComponent, SelectTuftProductComponent, TuftProductionOrderSettingsComponent]
})
export class TuftProductionOrderModule {}
